import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Modal as AntdModal } from 'antd';

import * as actions from '../../store/actions';
import { showModal, fetchTestSettings } from '../../store/actions/AssessmentActions';
import MediaPermissionComponent from '../Assessment/MediaPermission/MediaPermissionComponent';
import HomePageContainer from '../HomePageContainer/HomePageContainer';
import InviteUIContainer from '../InviteUI/InviteUIContainer';
import AssessmentContainer from '../Assessment/AssessmentContainer';
import Mcqs from '../Mcq/Mcqs';
import ProblemContainer from '../Problem/ProblemContainer';
import ErrorContainer from '../Error/ErrorContainer';
import InterviewInviteUIContainer from '../InterviewInviteUI/InterviewInviteUIContainer';
import BaseInterviewContainer from '../Interview/BaseInterviewContainer';
import FeedbackContainer from '../Interview/Feedback/FeedbackContainer';
import MediaSetupGuide from '../Assessment/MediaSetupGuide';
import Header from '../../components/Header/Header';
// import Footer from '../../components/Footer/Footer';
// import Modal from '../../components/UI/Modal/Modal';
import Wrapper from '../../HOC/Wrapper';
import TestComplete from '../../components/Problem/TestComplete';
import InterviewComplete from '../../components/Interview/InterviewComplete';
import { history } from '../../index';
import { AssessmentStatus } from '../../store/reducers/InviteReducer';

import FlashMessageList from '../../components/FlashMessageList/FlashMessageList';
import ErrorImage from '../../components/ErrorImage/ErrorImage';
import { problemsSelector, attemptedCountSelector } from '../../store/reducers/AssessmentReducer';

import styles from './MainContainer.scss';
import SectionsModal from '../../components/SectionsModal/SectionsModal';
import SurveyModal from '../../components/SurveyModala/SurveyModal';
import ProjectContainer from '../Projects/ProjectContainer';
import ScheduleContainer from '../Schedule/ScheduleContainer';
import PracticesTestLogin from '../PracticesTestLogin/PracticesTestLogin';
import PracticeAuthWrapper from '../../HOC/PracticeAuthWrapper';
import PracticeTestsContainer from '../PracticeTests/PracticeTestsContainer';
import PracticeTestInstructionsContainer from '../PracticeTestInstructions/PracticeTestInstructionsContainer';
import PracticeTestAttemptsContainer from '../PracticeTestAttempts/PracticeTestAttemptsContainer';
import PracticeTestResultContainer from '../PracticeTestResult/PracticeTestResultContainer';

let browserPrefixes = ['moz', 'ms', 'o', 'webkit'],
  isVisible = true; // internal flag to prevent multiple  fires, defaults to true

let hiddenPropertyName = null,
  visibilityEventName = null;

// get current browser vendor for visibilityAPI
for (var i = 0; i < browserPrefixes.length; i++) {
  let getHiddenPropertyName = browserPrefixes[i] + 'Hidden';
  if (getHiddenPropertyName in document) {
    hiddenPropertyName = getHiddenPropertyName;
    visibilityEventName = browserPrefixes[i] + 'visibilitychange';
    break;
  }
  hiddenPropertyName = 'hidden';
  visibilityEventName = 'visibilitychange';
}

class MainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      endInterview: false,
    };
  }

  attachEventListeners = () => {
    if (this.props.test_settings && this.props.test_settings.do_not_navigate_away) {
      window.addEventListener('blur', this.handleFocusBlur, false);
      document.addEventListener(visibilityEventName, this.handleVisibilityChange, false);
      window.addEventListener('focus', this.handleFocusBlur, false);
    }
    if (this.props.test_settings && this.props.test_settings.disable_copy_paste) {
      window.addEventListener('copy', this.preventCopyPaste, true);
      window.addEventListener('paste', this.preventCopyPaste, true);
      window.addEventListener('cut', this.preventCopyPaste, true);
    }
  };

  detachEventListeners = () => {
    if (this.props.test_settings && this.props.test_settings.do_not_navigate_away) {
      document.removeEventListener(visibilityEventName, this.handleVisibilityChange);
      window.removeEventListener('blur', this.handleFocusBlur, false);
      window.removeEventListener('focus', this.handleFocusBlur);
    }
    if (this.props.test_settings && this.props.test_settings.disable_copy_paste) {
      window.removeEventListener('copy', this.preventCopyPaste, true);
      window.removeEventListener('paste', this.preventCopyPaste, true);
      window.removeEventListener('cut', this.preventCopyPaste, true);
    }
  };

  preventCopyPaste = e => {
    console.log('triggred', e);

    e.preventDefault();
  };

  modalTriggerHandler = () => {
    if (this.props.showAuthModal) this.props.onToggleAuthModal('');
    this.props.onLoadModal({
      showModal: false,
      modalType: '',
      modalContent: null,
    });
  };

  handleLeavePage = e => {
    sessionStorage.setItem('tab_closed', true);
    this.props.tabClose();
  };

  shouldComponentUpdate(nextProps) {
    if (window.location.pathname.substring(1, 5) === 'http') {
      window.open(window.location.pathname.substring(1, window.location.pathname.length + 1));
      nextProps.location.pathname = this.props.location.pathname;
      nextProps.history.goBack();
      return false;
    }
    return true;
  }

  componentDidMount() {
    let urlparams = new URLSearchParams(this.props.location.search);
    if (!localStorage.getItem('company_id')) {
      if (urlparams.get('company_id'))
        localStorage.setItem('company_id', urlparams.get('company_id'));
    }
    this.props.fetchCompanyDetails();
    if (this.props.test_id) {
      this.props.fetchTestSettings(this.props.test_id);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.test_id && this.props.test_id !== prevProps.test_id) ||
      (this.props.user_detail.user_id &&
        this.props.user_detail.user_id !== prevProps.user_detail.user_id)
    ) {
      this.props.fetchTestSettings(this.props.test_id);
    }
    if (
      this.props.assessment_status === AssessmentStatus.InProgress &&
      this.props.test_settings &&
      (this.props.test_settings.do_not_navigate_away || this.props.test_settings.disable_copy_paste)
    ) {
      this.attachEventListeners();
    }
    if (
      this.props.assessment_status === AssessmentStatus.Completed &&
      this.props.test_settings &&
      (this.props.test_settings.do_not_navigate_away || this.props.test_settings.disable_copy_paste)
    ) {
      this.detachEventListeners();
    }
    if (
      this.props.assessment_status === AssessmentStatus.InProgress &&
      this.props.assessment_status !== prevProps.assessment_status &&
      this.props.assessment_id
    ) {
      this.attachEventListeners();
      window.addEventListener('beforeunload', this.handleLeavePage);
      // Commenting it out for now, We’ll handle it later through a configurable setting.
      // window.addEventListener('blur', this.handleFocusBlur, false);

      if (sessionStorage.getItem('tab_closed')) {
        this.props.refreshTab();
        sessionStorage.removeItem('tab_closed');
      }
    } else if (
      this.props.assessment_status === AssessmentStatus.Completed &&
      this.props.assessment_status !== prevProps.assessment_status
    ) {
      this.detachEventListeners();
      window.removeEventListener('beforeunload', this.handleLeavePage);
    }
    // Set currentSectionId based on URL if sections are loaded and currentSectionId is null
    if (this.props.sections && this.props.sections.length > 0 && !this.props.currentSectionId) {
      const path = this.props.location.pathname;
      if (path.includes('/assessment/')) {
        const parts = path.split('/').filter(p => p);
        const index = parts.indexOf('assessment');
        if (index !== -1 && parts.length > index + 1) {
          if (path.includes('/problem/')) {
            const problemIndex = parts.indexOf('problem');
            if (problemIndex !== -1 && parts.length > problemIndex + 1) {
              const problemId = parts[problemIndex + 1];
              const section = this.props.sections.find(
                s => s.problems && s.problems.includes(problemId),
              );
              if (section) {
                this.props.dispatch(actions.setCurrentSectionId(section.id));
              }
            }
          } else if (path.includes('/mcqs/')) {
            const mcqIndex = parts.indexOf('mcqs');
            if (mcqIndex !== -1 && parts.length > mcqIndex + 1) {
              const mcqId = parts[mcqIndex + 1];
              const section = this.props.sections.find(s => s.mcqs && s.mcqs.includes(mcqId));
              if (section) {
                this.props.dispatch(actions.setCurrentSectionId(section.id));
              }
            }
          } else if (path.includes('/section/')) {
            const sectionIndex = parts.indexOf('section');
            if (sectionIndex !== -1 && parts.length > sectionIndex + 1) {
              const sectionId = parts[sectionIndex + 1];
              this.props.dispatch(actions.setCurrentSectionId(sectionId));
            }
          }
        }
      }
    }
  }

  handleFocusBlur = event => {
    if (event.type === 'blur') return this.handleVisibilityChange(false);
    else return this.handleVisibilityChange(true);
  };

  handleVisibilityChange = forcedFlag => {
    //when blur/focus is fired
    if (typeof forcedFlag === 'boolean') {
      if (forcedFlag) {
        return this.onVisible();
      }
      return this.onHidden();
    }
    //when visibilityChangeAPI is fired
    else {
      if (document[hiddenPropertyName]) {
        return this.onHidden();
      }
      return this.onVisible();
    }
  };

  onHidden = () => {
    if (isVisible) {
      //change the flag state
      isVisible = false;
      this.props.documentLostFocus();
    }
  };

  onVisible = () => {
    if (!isVisible) {
      //change the flag state
      isVisible = true;
    }
  };

  submitTest = (assessmentId, testEnded = false) => {
    if (!testEnded) {
      let message =
        'You will not be able to make any further changes, your submission will be final.';
      this.props.dispatch(
        showModal({
          name: 'submit_test_confirm',
          type: 'confirm',
          title: 'Are you sure you want to submit the test?',
          content: message,
          onOk: () => {
            this.props.submitAssessment(assessmentId, true);
          },
          onCancel: () => {
            console.log('Cancel');
          },
        }),
      );
    } else {
      this.props.submitAssessment(assessmentId, false);
      this.props.dispatch(
        showModal({
          name: 'time_up_info',
          type: 'info',
          title: 'Time is up!',
          content: 'Your test has been submitted',
          onOk: async () => {
            await this.props.dispatch(actions.setSubmittedBy('candidate'));
            history.push(`/survey/assessment/${assessmentId}`);
          },
        }),
      );
    }
  };

  submitInterview = () => {
    this.props.dispatch(
      showModal({
        name: 'end_interview_confirm',
        type: 'confirm',
        title: 'End the Interview',
        content: 'Are you sure you want to end the interview?',
        okText: 'End Interview',
        cancelText: 'Go back',
        onOk: () => {
          this.setState({
            endInterview: true,
          });
        },
        onCancel: () => {
          console.log('Cancel');
        },
      }),
    );
  };

  documentLostFocusModal = () => {
    this.props.dispatch(
      showModal({
        name: 'document_lost_focus',
        type: 'warning',
        title: this.props.modal.modalType,
        content: this.props.modal.modalContent,
        onOk: () =>
          this.props.onLoadModal({
            showModal: false,
            modalType: '',
            modalContent: null,
          }),
      }),
    );
  };

  render() {
    let hideHeader = 'false';
    let partialHeader = 'false';
    let hideFooter = 'false';
    let isMeetingCreationInProgress = ['device-setup', 'waiting_lobby'].includes(
      this.props.current_page,
    );
    let isSectionInstruction = false;
    let isAssessmentRoute =
      window.location.pathname.includes('/assessment/') &&
      !window.location.pathname.includes('/survey');
    const hideHeaderFooterRoutes = [
      '/set_password/',
      '/testcomplete',
      '/interviewcomplete',
      '/interviewinvite',
      '/invite',
      '/error',
      '/recording',
      '/survey',
      '/project',
      '/schedule',
    ];

    const practiceTestRoutes = [
      '/practices-test',
      '/practices-instruction',
      '/practices-attempts',
      '/practices-result',
    ];

    if (
      hideHeaderFooterRoutes.some(route => window.location.pathname.includes(route)) ||
      window.location.pathname.includes('/practices-test/login')
    ) {
      hideHeader = 'true';
      hideFooter = 'true';
    } else if (practiceTestRoutes.some(route => window.location.pathname.includes(route))) {
      // Show simplified header with only logo for practice test routes
      partialHeader = 'true';
      hideFooter = 'true';
    }
    if (
      window.location.pathname.includes('/interview') ||
      window.location.pathname.includes('/viewresult')
    ) {
      partialHeader = 'true';
    }
    if (window.location.pathname.includes('/interview') && isMeetingCreationInProgress) {
      hideHeader = 'true';
      hideFooter = 'true';
    }

    if (window.location.pathname.includes('/interview') && !isMeetingCreationInProgress) {
      hideFooter = 'true';
      if (window.location.pathname.includes('/section')) {
        isSectionInstruction = true;
      }
    }

    console.log('Test Settings in MainContainer:', hideHeader);

    return (
      <React.Fragment>
        <FlashMessageList />
        {isAssessmentRoute &&
          this.props.test_settings?.enable_screen_and_camera &&
          (this.props.recoveryModalOpen ||
            (this.props.assessmentSubmissionStatus === '' && !this.props.meetingSession)) && (
            <>
              <div className={styles['media-recovery-overlay-notification-area']} />
              <div className={styles['media-recovery-overlay-content-area']}>
                <MediaPermissionComponent
                  assessment_id={this.props.assessment_id}
                  recoveryMode={true}
                />
              </div>
            </>
          )}
        <div
          className={`${
            isMeetingCreationInProgress ? styles['c-layout-theme'] : styles['c-layout']
          }`}
          style={isSectionInstruction ? { backgroundColor: 'var(--header-bg)' } : {}}
        >
          {hideHeader === 'true' ? null : (
            <div className={styles['c-layout__header']}>
              <Header
                attemptedCount={this.props.attemptedCount}
                totalCount={this.props.totalCount}
                assessmentId={this.props.assessmentId}
                submitTest={this.submitTest}
                timerWarnLevel={this.props.timerWarnLevel}
                setTimerExpLevel={this.props.setTimerExpLevel}
                partialHeader={partialHeader}
                participants={this.props.participants}
                submitInterview={this.submitInterview}
              />
            </div>
          )}
          <div
            className={styles['c-layout__content']}
            full={hideHeader}
          >
            <Switch>
              {this.props.notFound ? (
                <Route
                  render={props => (
                    <ErrorImage
                      {...props}
                      errorType={this.props.errorType}
                      errorHeading={this.props.errorHeading}
                      errorMessage={this.props.errorMessage}
                    />
                  )}
                />
              ) : null}
              <Route
                path="/home"
                exact
                component={HomePageContainer}
              />
              <Redirect
                exact
                from="/"
                to="/home"
              />
              <Route
                path="/assessment/:id"
                exact
                component={AssessmentContainer}
              />
              <Route
                path="/assessment/:assessment_id/mcqs/:mcq_id"
                exact
                component={Mcqs}
              />
              <Route
                path="/invite"
                exact
                render={props => <InviteUIContainer {...props} />}
              />
              <Route
                path="/project/:site?"
                component={ProjectContainer}
              />
              <Route
                path="/schedule"
                exact
                component={ScheduleContainer}
              />
              <Route
                path="/practices-test/login"
                exact
                component={PracticesTestLogin}
              />
              <Route
                path="/practices-test"
                exact
                render={props => (
                  <PracticeAuthWrapper>
                    <PracticeTestsContainer {...props} />
                  </PracticeAuthWrapper>
                )}
              />
              <Route
                path="/practices-instruction/:id"
                exact
                render={props => (
                  <PracticeAuthWrapper>
                    <PracticeTestInstructionsContainer {...props} />
                  </PracticeAuthWrapper>
                )}
              />
              <Route
                path="/practices-attempts/:testTitle/:testId"
                exact
                render={props => (
                  <PracticeAuthWrapper>
                    <PracticeTestAttemptsContainer {...props} />
                  </PracticeAuthWrapper>
                )}
              />
              <Route
                path="/practices-result/:assessmentId"
                exact
                render={props => (
                  <PracticeAuthWrapper>
                    <PracticeTestResultContainer {...props} />
                  </PracticeAuthWrapper>
                )}
              />
              <Route
                path="/assessment/:assessment_id/problem/:problem_id"
                exact
                component={ProblemContainer}
              />
              <Route
                path="/assessment/:assessment_id/section/:section_id"
                exact
                component={SectionsModal}
              />
              <Route
                path="/survey/assessment/:assessment_id"
                exact
                component={SurveyModal}
              />
              <Route
                path="/survey/interview/:interview_id"
                exact
                component={SurveyModal}
              />
              <Route
                path="/recording/:assessment_id"
                exact
                component={MediaSetupGuide}
              />
              <Route
                path="/error"
                exact
                render={props => (
                  <Wrapper>
                    <ErrorContainer />
                  </Wrapper>
                )}
              />
              {/* <Route
                path="/viewresult"
                exact
                render={props => (
                  <Wrapper>
                    <ViewResult />
                  </Wrapper>
                )}
              /> */}
              <Route
                path="/testcomplete"
                exact
                render={props => (
                  <Wrapper>
                    <TestComplete testTitle={this.props.test_title} />
                  </Wrapper>
                )}
              />
              <Route
                path="/interviewcomplete"
                exact
                render={props => (
                  <Wrapper>
                    <InterviewComplete />
                  </Wrapper>
                )}
              />
              <Route
                path="/interviewinvite"
                exact
                render={props => <InterviewInviteUIContainer />}
              />
              <Route
                path="/interview"
                exact
                render={props => (
                  <BaseInterviewContainer
                    {...props}
                    endInterview={this.state.endInterview}
                  />
                )}
              />
              <Route
                path="/interview/feedback"
                exact
                render={props => <FeedbackContainer />}
              />
              <Route
                render={props => (
                  <ErrorImage
                    {...props}
                    errorType="404"
                    errorHeading="Link not found"
                    errorMessage="THE REQUESTED URL WAS NOT FOUND"
                  />
                )}
              />
            </Switch>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

MainContainer.propTypes = {
  modal: PropTypes.object,
  onLoadModal: PropTypes.func,
  showAuthModal: PropTypes.string,
  onToggleAuthModal: PropTypes.func,
  location: PropTypes.object,
  user_detail: PropTypes.object,
  notFound: PropTypes.bool,
  errorType: PropTypes.string,
  errorHeading: PropTypes.string,
  errorMessage: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    modal: state.global.modal,
    showAuthModal: state.global.showAuthModal,
    user_detail: state.auth,
    notFound: state.global.notFound,
    errorType: state.global.errorType,
    errorHeading: state.global.errorHeading,
    errorMessage: state.global.errorMessage,
    attemptedCount: attemptedCountSelector(state.assessment),
    totalCount: problemsSelector(state.assessment).length,
    remainingTime: state.assessment.remainingTime,
    assessmentId: state.assessment.id,
    participants: state.interview.participants,
    test_title: state.assessment.test_title,
    interview_id: state.interview.interview_id,
    assessment_status: state.invite.assessment_status,
    assessment_id: state.invite.assessment_id,
    test_id: state.invite.test_id,
    test_settings: state.assessment.test_settings,
    timerWarnLevel: state.assessment.timerWarnLevel,
    current_page: state.meeting.current_page,
    sections: state.assessment.sections,
    currentSectionId: state.assessment.currentSectionId,
    screenShareInitiated: state.interviewRecording?.screenShareInitiated,
    recoveryModalOpen: state.assesmentRecording.recoveryModalOpen,
    meetingSession: state.assesmentRecording.meetingSession,
    assessmentStatus: state.assessment.status,
    assessmentSubmissionStatus: state.assessment.assessmentSubmissionStatus,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    onLoadModal: modal => dispatch(actions.onLoadModal(modal)),
    onToggleAuthModal: showAuthModal => dispatch(actions.onToggleAuthModal(showAuthModal)),
    submitAssessment: (assessmentId, redirect) =>
      dispatch(actions.submitAssessment(assessmentId, redirect)),
    setTimerExpLevel: level => dispatch(actions.setTimerExpLevel({ level: level })),
    documentLostFocus: () => dispatch(actions.documentLostFocus()),
    tabClose: () => dispatch(actions.tabClose()),
    refreshTab: () => dispatch(actions.refreshTab()),
    fetchCompanyDetails: () => dispatch(actions.fetchCompanyDetails()),
    fetchTestSettings: test_id => dispatch(fetchTestSettings(test_id)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainContainer));
